// Post add-to-cart confirmation - see snippets/post-atc-toast.liquid.
// The cart drawer is kept closed by assets/product-form.js while this element is on
// the page; this element confirms the add instead.
if (!customElements.get("post-atc-toast")) {
  customElements.define(
    "post-atc-toast",
    class PostAtcToast extends HTMLElement {
      constructor() {
        super();

        this.showFor = 3500;
        this.cardStateFor = 2500;
        this.token = 0;
        this.lastButton = null;

        this.nameEl = this.querySelector(".post-atc-toast__name");
        this.subEl = this.querySelector(".post-atc-toast__sub");
        this.linkEl = this.querySelector(".post-atc-toast__link");

        this.linkEl.addEventListener("click", () => {
          this.hide();
          document.querySelector(".wt-cart__trigger")?.click();
        });

        // Remember which card opened the quick view, and retire any toast still on
        // screen from an earlier add so it does not reappear when the panel closes.
        document.addEventListener(
          "click",
          (event) => {
            const button = event.target.closest?.("quick-add button");
            if (!button) return;
            this.lastButton = button;
            clearTimeout(this.timer);
            this.hide();
          },
          true,
        );

        subscribe(PUB_SUB_EVENTS.cartUpdate, (payload) =>
          this.onCartUpdate(payload),
        );
      }

      onCartUpdate(payload) {
        if (payload?.source !== "product-form") return;

        const data = payload.cartData || {};
        const item = data.items?.length ? data.items[0] : data;
        const quantity = item.quantity || 1;

        const parts = ["Added to cart", `Qty ${quantity}`];
        if (typeof item.line_price === "number") {
          parts.push(this.formatMoney(item.line_price));
        } else if (typeof item.price === "number") {
          parts.push(this.formatMoney(item.price * quantity));
        }

        this.show(
          item.product_title || item.title || "Item",
          parts.join(" · "),
          this.countFromSections(data),
        );
        this.flagCard();
      }

      show(name, sub, count) {
        this.nameEl.textContent = name;
        this.subEl.textContent = sub;
        this.linkEl.textContent = count ? `View cart (${count})` : "View cart";

        // Commit the resting style first so the toast always slides in.
        void this.offsetHeight;
        this.classList.add("post-atc-toast--show");

        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.hide(), this.showFor);

        // The count normally comes from the add response. If the response carried no
        // sections, wait for the header bubble to change: cartUpdate is published before
        // the bubble is re-rendered, so its current number is the pre-add count.
        const token = ++this.token;
        if (count) return;
        const before = this.cartCount();
        let tries = 0;
        const poll = () => {
          if (token !== this.token) return;
          const now = this.cartCount();
          if (now && now !== before) {
            this.linkEl.textContent = `View cart (${now})`;
            return;
          }
          if (++tries < 15) setTimeout(poll, 150);
        };
        setTimeout(poll, 150);
      }

      hide() {
        this.classList.remove("post-atc-toast--show");
      }

      flagCard() {
        const button = this.lastButton;
        if (!button) return;
        this.lastButton = null;

        const label = button.querySelector("span") || button;

        // Keep the original label from the first add, so a second add inside the
        // "Added" window does not store "✓ Added" as the label to restore.
        if (button.postAtcTimer) {
          clearTimeout(button.postAtcTimer);
        } else {
          button.postAtcLabel = label.textContent;
        }

        button.classList.add("post-atc-toast__added");
        label.textContent = "✓ Added";

        button.postAtcTimer = setTimeout(() => {
          button.classList.remove("post-atc-toast__added");
          label.textContent = button.postAtcLabel;
          button.postAtcTimer = null;
        }, this.cardStateFor);
      }

      // The add response carries the re-rendered cart-icon-bubble section, which
      // already holds the new item count.
      countFromSections(data) {
        const html = data?.sections?.["cart-icon-bubble"];
        if (!html) return null;
        const holder = document.createElement("div");
        holder.innerHTML = html;
        return holder.textContent.match(/\d+/)?.[0] || null;
      }

      cartCount() {
        const bubble = document.getElementById("cart-icon-bubble");
        return bubble?.textContent.match(/\d+/)?.[0] || null;
      }

      // Prices render as "$28.99 USD". narrowSymbol avoids "US$" on non-US locales.
      formatMoney(cents) {
        const code = window.Shopify?.currency?.active || "USD";
        let amount;
        try {
          amount = new Intl.NumberFormat(undefined, {
            style: "currency",
            currency: code,
            currencyDisplay: "narrowSymbol",
          }).format(cents / 100);
        } catch (e) {
          amount = (cents / 100).toFixed(2);
        }
        return amount.includes(code) ? amount : `${amount} ${code}`;
      }
    },
  );
}
